import React, { PropsWithChildren, memo } from 'react';
import Span from '../Span';
import classNames from 'classnames';

type MetadataProps = {
  className?: string;
  textColor?: string;
  background?: string;
  dataTestId?: string;
  style?: any;
};

const Metadata = ({
  children,
  className,
  textColor = 'text-amc-efbrand',
  background = 'bg-blue-100',
  dataTestId,
  style,
  ...restProps
}: PropsWithChildren<MetadataProps>) => {
  return (
    <Span
      className={classNames(
        'h-fit text-body-sm md:text-body-sm-desktop px-2 pb-1 pt-0.5 border-blue-200 rounded-cxxs',
        textColor,
        background,
        className,
      )}
      dataTestId={dataTestId}
      style={style}
      {...restProps}
    >
      {children}
    </Span>
  );
};

export default memo(Metadata);
